import { mapOptionsToQueryParams } from './video.utils';
import { PrivateCatalogService } from '../../../catalog-services/private-catalog-service';
export class PrivateVideo extends PrivateCatalogService {
    /**
     * @param videos - array of videos
     * @param requestConfig
     */
    createVideos(videos, requestConfig) {
        return this.post('/catalog/items', { items: videos }, requestConfig);
    }
    /**
     * @param query
     * @param tag
     * @param category
     * @param mediaType
     * @param sort
     * @param paging
     * @param itemType
     * @param requestConfig
     */
    getList({ query, tag, category, mediaType, sort, paging, itemType }, requestConfig) {
        const params = mapOptionsToQueryParams({
            query,
            tag,
            category,
            mediaType,
            sort,
            paging,
            itemType,
        });
        return this.get('/catalog/items', {
            params,
            ...requestConfig,
        });
    }
    /**
     * @param videoIds - array of video ids
     * @param requestConfig
     */
    removeVideos(videoIds, requestConfig) {
        return this.delete('/catalog/items/delete', {
            ...requestConfig,
            params: { items: videoIds },
        });
    }
    /**
     * @param videoId
     * @param requestConfig
     */
    getById(videoId, requestConfig) {
        return this.get(`/catalog/items/${videoId}`, requestConfig);
    }
    /**
     * @param videoId
     * @param video
     * @param requestConfig
     */
    updateById(videoId, video, requestConfig) {
        return this.put(`/catalog/items/${videoId}`, video, {
            ...requestConfig,
        });
    }
    patchById(videoId, video, requestConfig) {
        return this.patch(`/catalog/items/${videoId}`, video, {
            ...requestConfig,
        });
    }
    /**
     * @param videoIds
     * @param video
     * @param requestConfig
     */
    batchUpdateVideos(videoIds, video, requestConfig) {
        const data = {
            ...video,
            items: videoIds,
        };
        return this.put(`/catalog/items`, data, {
            ...requestConfig,
        });
    }
    getVideoUrlsByFileName(name, { clip, autogenerated } = {}, requestConfig) {
        return this.get(`/catalog/videos/${name}/play`, {
            params: {
                clip,
                autogenerated,
            },
            ...requestConfig,
        });
    }
    /**
     * @param {string} videoId
     * @param requestConfig
     */
    createSingleVideo(videoId, requestConfig) {
        return this.post(`/publisher/items/${videoId}/create`, null, requestConfig);
    }
    generateVideoTrailer(videoId) {
        return this.post(`/catalog/items/${videoId}/generate-trailer`);
    }
}
//# sourceMappingURL=video.js.map